import styled from 'styled-components';

export const ModalMenuTreeWrapper = styled.div`
    width: 100%;
    background-color: #fff;
    height: 100%;
    position: absolute;
    border-radius: ${({ theme }) => theme.borderRadius.extraLarge};
`;
